<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Puntos desde los que vendes. Puede ser tienda física,
                eCommerce, HUB de rutas o tienda virtual con IA. Úsalo
                para abrir un punto nuevo, conectarlo a almacenes y definir
                qué clientes atiende.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Oficinas de Ventas
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>oficinas de venta</b> que operan dentro de AVE para una
          <b>compañia</b>.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Oficinas de Ventas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>

          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nombre
                </th>
                <td mat-cell *matCellDef="let salesoffice" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(salesoffice) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ salesoffice.name }}
                </td>
              </ng-container>

              <!-- Grupo de Oficina -->
              <ng-container matColumnDef="officeGroup">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Grupo de Oficina
                </th>
                <td mat-cell *matCellDef="let salesoffice" class="text-sm">
                  {{ salesoffice.officeGroup?.name }}
                </td>
              </ng-container>

              <!-- Compania -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Compañía
                </th>
                <td mat-cell *matCellDef="let salesoffice" class="text-sm uppercase">
                  {{ salesoffice?.company?.name }}
                </td>
              </ng-container>

              <!-- Dirección -->
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Dirección
                </th>
                <td mat-cell *matCellDef="let salesoffice" class="text-sm">
                  {{ salesoffice?.address?.address || 'N/A' }}
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Estado
                </th>
                <td mat-cell *matCellDef="let salesoffice" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="salesoffice.statusId == 1"
                    [(ngModel)]="salesoffice.statusId" [color]="'success'"
                    (ngModelChange)="onStatusChange($event, salesoffice)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let salesoffice" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(salesoffice)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(salesoffice)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold pb-4 border-b border-gray-200 dark:border-gray-700">Nuevo Registro
      </h2>
      <mat-dialog-content class="overflow-y-auto" style="max-height: 70vh;">
        <mat-tab-group class="mt-4" (selectedIndexChange)="onCreateTabChanged($event)">
          <!-- TAB 1: Información General -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2">
                <mat-icon *ngIf="!checkGeneralFormValidity(createForm) && selectedCreateTabIndex !== 0"
                  class="text-red-500">error</mat-icon>
                Información General
                <span *ngIf="!checkGeneralFormValidity(createForm) && selectedCreateTabIndex !== 0"
                  class="ml-1 px-2 py-0.5 rounded bg-red-600 text-white text-xs" matBadge="!" matBadgeColor="warn"
                  matBadgeSize="small">
                  Requerido
                </span>
              </span>
            </ng-template>
            <div class="py-6 px-2">
              <form #createForm="ngForm">
                <app-form-section title="Información Básica" icon="business_center" color="blue" class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field class="w-full">
                        <mat-label>Nombre</mat-label>
                        <input matInput [(ngModel)]="currentCreateSalesOffice.name" name="name" required />
                      </mat-form-field>
                      <mat-form-field class="w-full">
                        <mat-label>Tipo</mat-label>
                        <mat-select [(ngModel)]="currentCreateSalesOffice.type" name="type">
                          <mat-option *ngFor="let type of salesOfficeType" [value]="type.value">
                            {{ type.key | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <!-- Select Compañía -->
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                        <ng-select [(ngModel)]="currentCreateSalesOffice.companyid" [items]="companyList"
                          bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía"
                          name="companyid" [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                      <!-- Select Group Office -->
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Grupo de Oficinas
                          de Venta</label>
                        <ng-select [(ngModel)]="currentCreateSalesOffice.officeGroupId" [items]="officeGroupList"
                          bindLabel="name" bindValue="_id" [searchable]="true"
                          placeholder="Seleccione un grupo de oficinas de venta" name="officeGroupId"
                          [appendTo]="'body'">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </app-form-section>

                <app-form-section title="Configuración de Canales" icon="alt_route" color="green"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="group-select" class="block text-gray-700">Canal</mat-label>
                          <mat-select [(ngModel)]="selectedChannel" name="selectedChannel"
                            (selectionChange)="changeChannel()">
                            <mat-option>
                              <ngx-mat-select-search [(ngModel)]="searchChannel" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changeOptionsChannel($event)" placeholderLabel="Buscar..."
                                noEntriesFoundLabel="No se encontraron resultados">
                              </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let type of listFilterChannelList" [value]="type.id">{{ type.name
                              }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Cadena de
                          Distribución</label>
                        <ng-select [(ngModel)]="currentCreateSalesOffice.distributionChainId"
                          [items]="distributionChainList" bindLabel="name" bindValue="_id" [searchable]="true"
                          placeholder="Seleccione una cadena de distribución" name="distributionChainId"
                          [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                    </div>
                    <mat-form-field class="w-full">
                      <mat-label for="group-select">Cadenas de distribución que heredan los clientes</mat-label>
                      <mat-select [formControl]="distributionMultiCtrl" placeholder="Seleccione cadenas de distribución"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAllDistribution($event)"
                            [formControl]="distributionMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar cadenas...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let distribution of filteredDistribution | async" [value]="distribution">
                          <ng-container *ngIf="getCode(distribution) as code">
                            <b class="f-12">{{ code }}</b> -
                          </ng-container>
                          {{ distribution.name }}
                        </mat-option>
                      </mat-select>
                      <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                      <mat-error *ngIf="
                    distributionMultiCtrl.hasError('required') &&
                    (distributionMultiCtrl.dirty || distributionMultiCtrl.touched)
                  ">
                        Seleccione cadenas de distribución
                      </mat-error>
                    </mat-form-field>
                  </div>
                </app-form-section>

                <!-- <div class="col-span-1">
            <label for="group-select">Cadenas de distribución que heredan los clientes</label>
            <ng-select
              [(ngModel)]="currentCreateSalesOffice.distributionChainsInheritIds"
              [items]="distributionChainList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              [multiple]="true"
              placeholder="Seleccione cadenas de distribución"
              name="distributionChainsInheritIds"
              [appendTo]="'body'"
            ></ng-select>
          </div> -->
                <!-- Select division -->
                <!-- <div class="col-span-1">
                <label for="group-select">Divisiones</label>
                <ng-select
                  [(ngModel)]="currentCreateSalesOffice.divisionIds"
                  [items]="divisionList"
                  bindLabel="name"
                  bindValue="_id"
                  [searchable]="true"
                  [multiple]="true"
                  placeholder="Seleccione divisiones"
                  name="divisionIds"
                  [appendTo]="'body'"
                  required
                ></ng-select>
              </div> -->
                <app-form-section title="Configuración Organizacional" icon="account_tree" color="purple"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <mat-form-field class="w-full">
                      <mat-label for="group-select">Divisiones</mat-label>
                      <mat-select [formControl]="divisionMultiCtrl" placeholder="Seleccione divisiones"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDiv"
                            [toggleAllCheckboxChecked]="isCheckedDiv" (toggleAll)="toggleSelectAllDivision($event)"
                            [formControl]="divisionMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar divisiones...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let division of filteredDivision | async" [value]="division">
                          <ng-container *ngIf="getCode(division) as code">
                            <b class="f-12">{{ code }}</b> -
                          </ng-container>
                          {{ division.name }}
                        </mat-option>
                      </mat-select>
                      <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                      <mat-error *ngIf="
                        divisionMultiCtrl.hasError('required') &&
                        (divisionMultiCtrl.dirty || divisionMultiCtrl.touched)
                      ">
                        Seleccione una division
                      </mat-error>
                    </mat-form-field>
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Planta<span
                            class="text-red-500 ml-1">*</span></label>
                        <ng-select [(ngModel)]="currentCreateSalesOffice.plantId" [items]="plants" bindLabel="name"
                          bindValue="_id" [searchable]="true" [appendTo]="'body'" placeholder="Selecciona una planta"
                          name="plantId" required>
                          <!--(ngModelChange)="onPlantSelectionChange($event)"-->
                          <ng-template ng-label-tmp let-item="item">
                            <span *ngIf="item?.externalKeys"><b>{{ item?.externalKeys?.code }}</b> -
                            </span><span>{{item.name}}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="group-select">Almacenes</mat-label>
                          <mat-select [formControl]="warehouseMultiCtrl" placeholder="Seleccione los almacenes"
                            [multiple]="true">
                            <mat-option>
                              <ngx-mat-select-search [showToggleAllCheckbox]="true"
                                [toggleAllCheckboxIndeterminate]="isIndeterminate"
                                [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAllWarehouse($event)"
                                [formControl]="warehouseMultiFilterCtrl"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"
                                [clearSearchLabel]="'Limpiar búsqueda'"
                                [placeholderLabel]="'Buscar almacenes...'"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let warehouse of filteredWarehouses | async" [value]="warehouse">
                              <span *ngIf="warehouse?.externalKeys"><b>{{ warehouse?.externalKeys?.code }}</b> -
                              </span>{{
                              warehouse.name }}
                            </mat-option>
                          </mat-select>
                          <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                          <mat-error *ngIf="
                            warehouseMultiCtrl.hasError('required') &&
                            (warehouseMultiCtrl.dirty || warehouseMultiCtrl.touched)
                          ">
                            Seleccione los almacenes
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="bonus-select">Tratamiento de bonificaciones manuales</mat-label>
                          <mat-select [(ngModel)]="currentCreateSalesOffice.manualBonusHandling" name="manualBonusHandling"
                            placeholder="Seleccione un tratamiento de bonificación manual">
                            <mat-option>
                              <ngx-mat-select-search [formControl]="bonusFilterCtrl"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"
                                [clearSearchLabel]="'Limpiar búsqueda'" [placeholderLabel]="'Buscar bonificaciones...'">
                              </ngx-mat-select-search>
                            </mat-option>

                            <mat-option *ngFor="let bonus of filteredBonusOptions | async" [value]="bonus.value">
                              {{ bonus.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </app-form-section>

              </form>
            </div>
          </mat-tab>

          <!-- TAB 2: Dirección -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2">
                <mat-icon *ngIf="isAddressFormInitialized && isAddressValid === false && selectedCreateTabIndex !== 1"
                  class="text-red-500">error</mat-icon>
                Dirección
                <span *ngIf="isAddressFormInitialized && isAddressValid === false && selectedCreateTabIndex !== 1"
                  class="ml-1 px-2 py-0.5 rounded bg-red-600 text-white text-xs" matBadge="!" matBadgeColor="warn"
                  matBadgeSize="small">
                  Requerido
                </span>
              </span>
            </ng-template>
            <div class="py-6 px-2">
              <app-sales-office-address-form [address]="currentCreateSalesOfficeAddress"
                (addressChange)="onAddressChange($event)" (formValidityChange)="onAddressValidityChange($event)">
              </app-sales-office-address-form>
            </div>
          </mat-tab>

        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createSalesOffice()"
          [disabled]="!createForm.valid || isAddressValid !== true" [matTooltip]="getDisabledTooltip(createForm?.valid)"
          [matTooltipDisabled]="createForm?.valid && isAddressValid === true">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold pb-4 border-b border-gray-200 dark:border-gray-700">Editar Registro
      </h2>
      <mat-dialog-content class="overflow-y-auto" style="max-height: 70vh;">
        <mat-tab-group class="mt-4" (selectedIndexChange)="onEditTabChanged($event)">
          <!-- TAB 1: Información General -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2">
                <mat-icon *ngIf="!checkGeneralFormValidity(editForm) && selectedEditTabIndex !== 0"
                  class="text-red-500">error</mat-icon>
                Información General
                <span *ngIf="!checkGeneralFormValidity(editForm) && selectedEditTabIndex !== 0"
                  class="ml-1 px-2 py-0.5 rounded bg-red-600 text-white text-xs" matBadge="!" matBadgeColor="warn"
                  matBadgeSize="small">
                  Requerido
                </span>
              </span>
            </ng-template>
            <div class="py-6 px-2">
              <form #editForm="ngForm">
                <app-form-section title="Información Básica" icon="business_center" color="blue" class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <mat-form-field class="w-full">
                        <mat-label>Nombre</mat-label>
                        <input matInput [(ngModel)]="currentUpdateSalesOffice.name" name="name" required />
                      </mat-form-field>
                      <mat-form-field class="w-full">
                        <mat-label>Tipo</mat-label>
                        <mat-select [(ngModel)]="currentUpdateSalesOffice.type" name="type">
                          <mat-option *ngFor="let model of salesOfficeType" [value]="model.value">
                            {{ model.key | transloco}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <!-- Select Compañía -->
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Compañía</label>
                        <ng-select [(ngModel)]="currentUpdateSalesOffice.company" [items]="companyList" bindLabel="name"
                          bindValue="_id" [searchable]="true" placeholder="Seleccione una compañía" name="companyid"
                          [compareWith]="compareById" (ngModelChange)="onCompanySelectionChange($event)"
                          [appendTo]="'body'" required>
                        </ng-select>
                      </div>
                      <!-- Select Group Office -->
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Grupo de Oficinas
                          de Venta</label>
                        <ng-select [(ngModel)]="currentUpdateSalesOffice.officeGroup" [items]="officeGroupList"
                          bindLabel="name" bindValue="_id" [searchable]="true"
                          placeholder="Seleccione un grupo de oficinas de venta" name="officeGroupId"
                          [compareWith]="compareById" (ngModelChange)="onofficeGroupSelectionChange($event)"
                          [appendTo]="'body'">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </app-form-section>

                <app-form-section title="Configuración de Canales" icon="alt_route" color="green"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="group-select" class="block text-gray-700">Canal</mat-label>
                          <mat-select [(ngModel)]="selectedChannel" name="selectedChannel"
                            (selectionChange)="changeChannel()">
                            <mat-option>
                              <ngx-mat-select-search [(ngModel)]="searchChannel" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changeOptionsChannel($event)" placeholderLabel="Buscar..."
                                noEntriesFoundLabel="No se encontraron resultados">
                              </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let type of listFilterChannelList" [value]="type.id">{{ type.name
                              }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Cadena de
                          Distribución</label>
                        <ng-select [(ngModel)]="currentUpdateSalesOffice.distributionchain"
                          [items]="distributionChainList" bindLabel="name" bindValue="_id" [searchable]="true"
                          placeholder="Seleccione una cadena de distribución" name="distributionChainId"
                          [compareWith]="compareById" (ngModelChange)="ondistributionChainSelectionChange($event)"
                          [appendTo]="'body'">
                        </ng-select>
                      </div>
                    </div>
                    <mat-form-field class="w-full">
                      <mat-label for="group-select">Cadenas de distribución que heredan los clientes</mat-label>
                      <mat-select [formControl]="distributionMultiCtrl" placeholder="Seleccione cadenas de distribución"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDistrib"
                            [toggleAllCheckboxChecked]="isCheckedDistrib"
                            (toggleAll)="toggleSelectAllDistribution($event)"
                            [formControl]="distributionMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar cadenas...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let distribution of filteredDistribution | async" [value]="distribution">
                          <ng-container *ngIf="getCode(distribution) as code">
                            <b class="f-12">{{ code }}</b> -
                          </ng-container>
                          {{ distribution.name }}
                        </mat-option>
                      </mat-select>
                      <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                      <mat-error *ngIf="
                    distributionMultiCtrl.hasError('required') &&
                    (distributionMultiCtrl.dirty || distributionMultiCtrl.touched)
                  ">
                        Seleccione cadenas de distribución
                      </mat-error>
                    </mat-form-field>
                  </div>
                </app-form-section>

                <app-form-section title="Configuración Organizacional" icon="account_tree" color="purple"
                  class="space-y-4 mb-4">
                  <div class="space-y-4">
                    <mat-form-field class="w-full">
                      <mat-label for="group-select">Divisiones</mat-label>
                      <mat-select [formControl]="divisionMultiCtrl" placeholder="Seleccione divisiones"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDiv"
                            [toggleAllCheckboxChecked]="isCheckedDiv" (toggleAll)="toggleSelectAllDivision($event)"
                            [formControl]="divisionMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar divisiones...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let division of filteredDivision | async" [value]="division">
                          <ng-container *ngIf="getCode(division) as code">
                            <b class="f-12">{{ code }}</b> -
                          </ng-container>
                          {{ division.name }}
                        </mat-option>
                      </mat-select>
                      <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                      <mat-error *ngIf="
                        divisionMultiCtrl.hasError('required') &&
                        (divisionMultiCtrl.dirty || divisionMultiCtrl.touched)
                      ">
                        Seleccione una division
                      </mat-error>
                    </mat-form-field>
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Planta<span
                            class="text-red-500 ml-1">*</span></label>
                        <ng-select [(ngModel)]="currentUpdateSalesOffice.plant._id" [items]="plants" bindLabel="name"
                          bindValue="_id" [searchable]="true" [appendTo]="'body'" placeholder="Selecciona una planta"
                          name="plantId" required>
                          <!--(ngModelChange)="onPlantSelectionChange($event)"-->
                          <ng-template ng-label-tmp let-item="item">
                            <span *ngIf="item?.externalKeys"><b>{{ item?.externalKeys?.code }}</b> -
                            </span><span>{{item.name}}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="group-select">Almacenes</mat-label>
                          <mat-select [formControl]="warehouseMultiCtrl" placeholder="Seleccione los almacenes"
                            [multiple]="true">
                            <mat-option>
                              <ngx-mat-select-search [showToggleAllCheckbox]="true"
                                [toggleAllCheckboxIndeterminate]="isIndeterminate"
                                [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAllWarehouse($event)"
                                [formControl]="warehouseMultiFilterCtrl"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"
                                [clearSearchLabel]="'Limpiar búsqueda'"
                                [placeholderLabel]="'Buscar almacenes...'"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let warehouse of filteredWarehouses | async" [value]="warehouse">
                              <span *ngIf="warehouse?.externalKeys"><b>{{ warehouse?.externalKeys?.code }}</b> -
                              </span>{{
                              warehouse.name }}
                            </mat-option>
                          </mat-select>
                          <!-- Mensaje de error si no se ha seleccionado ningún valor -->
                          <mat-error *ngIf="
                            warehouseMultiCtrl.hasError('required') &&
                            (warehouseMultiCtrl.dirty || warehouseMultiCtrl.touched)
                          ">
                            Seleccione los almacenes
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label for="bonus-select">Tratamiento de bonificaciones manuales</mat-label>
                          <mat-select [(ngModel)]="currentUpdateSalesOffice.manualBonusHandling" name="manualBonusHandling"
                            placeholder="Seleccione un tratamiento de bonificación manual">
                            <mat-option>
                              <ngx-mat-select-search [formControl]="bonusFilterCtrl"
                                [noEntriesFoundLabel]="'No se encontraron resultados'"
                                [clearSearchLabel]="'Limpiar búsqueda'" [placeholderLabel]="'Buscar bonificaciones...'">
                              </ngx-mat-select-search>
                            </mat-option>

                            <mat-option *ngFor="let bonus of filteredBonusOptions | async" [value]="bonus.value">
                              {{ bonus.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </app-form-section>

              </form>
            </div>
          </mat-tab>

          <!-- TAB 2: Dirección -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2">
                <mat-icon *ngIf="isAddressFormInitialized && isAddressValid === false && selectedEditTabIndex !== 1"
                  class="text-red-500">error</mat-icon>
                Dirección
                <span *ngIf="isAddressFormInitialized && isAddressValid === false && selectedEditTabIndex !== 1"
                  class="ml-1 px-2 py-0.5 rounded bg-red-600 text-white text-xs" matBadge="!" matBadgeColor="warn"
                  matBadgeSize="small">
                  Requerido
                </span>
              </span>
            </ng-template>
            <div class="py-6 px-2">
              <app-sales-office-address-form [address]="currentUpdateSalesOfficeAddress"
                (addressChange)="onAddressChange($event)" (formValidityChange)="onAddressValidityChange($event)">
              </app-sales-office-address-form>
            </div>
          </mat-tab>

          <!-- TAB: Datos de Contacto -->
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2">
                Datos de Contacto
              </span>
            </ng-template>

            <div class="py-6 px-2 flex flex-col gap-6">
              <app-sales-office-phone-section [(phones)]="currentUpdateSalesOffice.phones"
                (phonesChange)="onPhoneChanged($event)" (phoneDelete)="onPhoneDeleted($event)"
                (phoneStatusChange)="onPhoneStatusChanged($event)">
              </app-sales-office-phone-section>

              <app-sales-office-email-section [emails]="currentUpdateSalesOffice.emails"
                (emailsChange)="onEmailChanged($event)" (emailDelete)="onEmailDeleted($event)"
                (emailStatusChange)="onEmailStatusChanged($event)">
              </app-sales-office-email-section>

            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateSalesOffice(currentUpdateSalesOffice._id)"
          [disabled]="!editForm.valid || isAddressValid !== true" [matTooltip]="getDisabledTooltip(editForm?.valid)"
          [matTooltipDisabled]="editForm?.valid && isAddressValid === true">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [officeGroup]="true"
      [loadData]="loadFiltersData"></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>